import { httpApi } from '@app/api/http.api';
import {
  Announcement,
  CreateAnnouncementDto,
  UpdateAnnouncementDto,
  AnnouncementPaginatedResponse,
  AnnouncementFilters,
} from '@app/types/api.types';

export const createAnnouncement = (data: CreateAnnouncementDto): Promise<Announcement> =>
  httpApi.post<Announcement>('/announcements', data).then(({ data }) => data);

export const getAnnouncements = (filters?: AnnouncementFilters): Promise<AnnouncementPaginatedResponse> =>
  httpApi
    .get<AnnouncementPaginatedResponse>('/announcements', { params: filters })
    .then(({ data }) => data);

export const getAnnouncementById = (id: string): Promise<Announcement> =>
  httpApi.get<Announcement>(`/announcements/${id}`).then(({ data }) => data);

export const updateAnnouncement = (id: string, data: UpdateAnnouncementDto): Promise<Announcement> =>
  httpApi.patch<Announcement>(`/announcements/${id}`, data).then(({ data }) => data);

export const deleteAnnouncement = (id: string): Promise<void> =>
  httpApi.delete<void>(`/announcements/${id}`).then(() => undefined);

